<template>
	<div class="container-fluid conteudo" :key="responsivity">
		<div>
			<div v-if="cabecalho" class="fl-cabecalho">
				<div class="row">
					<div class="col-lg-4 col-xs-12">
						<i class="icon icon-novo_cadastro"></i>
						<h3>
							{{ _traducao('global', 'cadastroFornecedor').toUpperCase() }}
						</h3>
						<h4 @click="_exibeSub('ad')" style="cursor: pointer">
							{{ _traducao('menu', 'menuAdministracao').toUpperCase() }}
							{{ _traducao('menu', 'menuGeral').toUpperCase() }}
							<i class="fa fa-angle-down" aria-hidden="true"></i>
						</h4>
					</div>
				</div>
			</div>

			<div class="row">
				<div class="col-xs-12">
					<div class="text-center" v-show="load">
						<flCarregando />
					</div>
				</div>
			</div>

			<div class="row" v-show="!load" style="margin-top: 20px">
				<!-- tabela com os cargos -->
				<div class="col-xs-7">
					<!-- busca -->
					<div class="row">
						<div class="col-md-8">
							<i
								class="fa fa-search icone-busca"
								style="top: 8px"
								aria-hidden="true"
							></i>
							<input
								type="text"
								style="padding-left: 25px"
								:placeholder="_traducao('global', 'buscar')"
								@keyup="filtra()"
								v-model="tabela.busca"
								class="form-control"
							/>
						</div>

						<div class="col-xs-4">
							<button
								type="button"
								@click="exibirNovo"
								class="btn btn-block pull-right btn-default"
							>
								<i
									class="icon-solicitacao_nova_solicitacao"
									style="margin-top: 1px; margin-right: 3px; float: left"
								></i>
								{{ _traducao('global', 'novo') }}
							</button>
						</div>
					</div>

					<!-- lista -->
					<div class="row" style="margin-top: 8px">
						<div class="col-xs-12">
							<table class="table table-lista table-striped table-hover">
								<thead>
									<tr>
										<th style="width: 40%">
											{{ _traducao('global', 'razaoSocial') }}
										</th>
										<th>
											{{ _traducao('global', 'cnpj') }}
										</th>
										<th>
											{{ _traducao('global', 'nomeContato') }}
										</th>
										<th class="text-center">
											{{ _traducao('global', 'opcoes') }}
										</th>
									</tr>
								</thead>
								<tbody>
									<tr
										v-for="(item, index) in tabela.listaChunk[
											tabela.pagination.currentPage - 1
										]"
										:key="index"
									>
										<td>{{ item.razao_social }}</td>
										<td>{{ item.cnpj }}</td>
										<td v-if="item.fornecedor_contato[0]">
											{{ item.fornecedor_contato[0].nome }}
										</td>
										<td v-else></td>
										<td class="text-center">
											<a
												href="#"
												@click.prevent="excluir(item)"
												style="margin-left: 5px"
												v-tooltip="_traducao('global', 'excluir')"
											>
												<i class="fa icon-lixeira" style="font-size: 20px"></i>
											</a>
											<a
												href="#"
												@click.prevent="editar(item)"
												style="margin-left: 5px"
												v-tooltip="_traducao('global', 'editar')"
											>
												<i class="fa icon-editar" style="font-size: 20px"></i>
											</a>
										</td>
									</tr>
								</tbody>
								<fl-rodape-tabela :length="tabela.listaChunk.length" />
							</table>
						</div>
					</div>

					<!-- paginacao -->
					<div class="row">
						<div class="col-md-12 text-center">
							<nav>
								<ul
									class="pagination"
									:class="{'pagination-sm': !_isMobile}"
									style="margin: 0px"
								>
									<li :class="{disabled: tabela.pagination.currentPage == 1}">
										<a href="#" @click.prevent="previous">
											<span aria-hidden="true">
												<i class="fa fa-angle-left" aria-hidden="true"></i>
											</span>
										</a>
									</li>
									<li
										v-for="(item, idxPg) in tabela.pagination.pageNumbers"
										:key="idxPg"
										:class="{active: item == tabela.pagination.currentPage}"
									>
										<a href="#" @click.prevent="page(item)">{{ item }}</a>
									</li>
									<li
										:class="{
											disabled:
												tabela.pagination.currentPage ==
												tabela.pagination.totalPages
										}"
									>
										<a href="#" @click.prevent="next">
											<span aria-hidden="true"
												><i class="fa fa-angle-right" aria-hidden="true"></i
											></span>
										</a>
									</li>
								</ul>
							</nav>
						</div>
					</div>
				</div>

				<!-- formulário -->
				<div class="col-xs-5" v-show="exibirForm" style="padding-left: 0px">
					<div class="row">
						<div class="col-xs-6" style="color: #555; font-size: 14px">
							<h3 v-show="form.id != 0" style="margin: 0px">
								<i
									class="icon icon-solicitacao_editar_solicitacao"
									style="margin-top: 1px; float: left; margin-right: 7px"
								></i>
								{{ _traducao('global', 'editar') }}
							</h3>

							<h3 v-show="form.id == 0" style="margin: 0px">
								<i
									class="icon icon-solicitacao_nova_solicitacao"
									style="margin-top: 1px; float: left; margin-right: 7px"
								></i>
								{{ _traducao('global', 'novo') }}
							</h3>
						</div>

						<div class="col-xs-6">
							<button
								type="button"
								@click="exibirForm = false"
								class="btn pull-right btn-xs btn-default"
							>
								<i class="fa fa-times"></i> {{ _traducao('global', 'fechar') }}
							</button>
						</div>
					</div>

					<div class="row">
						<div class="col-xs-12">
							<hr style="margin-top: 2px; margin-bottom: 10px" />
						</div>
					</div>

					<div class="row">
						<div
							class="col-md-12 form-group"
							:class="{'has-error': erro.razaoErro != ''}"
						>
							<label
								><span class="no-print">*</span
								>{{ _traducao('global', 'razaoSocial') }}:</label
							>
							<input
								type="text"
								@input="form.razao_social = $event.target.value.toUpperCase()"
								v-model="form.razao_social"
								class="form-control input-sm"
							/>
							<p class="help-block" v-show="erro.razaoErro">
								{{ erro.razaoErro }}
							</p>
						</div>
					</div>
					<div class="row">
						<div
							class="col-md-4 form-group"
							:class="{'has-error': erro.empresaEstrangeiraErro != ''}"
						>
							<label
								><span class="no-print">*</span
								>{{ _traducao('global', 'empresaEstrangeira') }}?:</label
							>
							<br />
							<div class="btn-group print-button-group" role="group">
								<button
									type="button"
									@click="form.empresaEstrangeira = '1'"
									:class="{'btn-info': form.empresaEstrangeira == '1'}"
									class="btn btn-default btn-sm"
								>
									{{ _traducao('global', 'sim') }}
								</button>
								<button
									type="button"
									@click="form.empresaEstrangeira = '0'"
									:class="{'btn-info': form.empresaEstrangeira == '0'}"
									class="btn btn-default btn-sm"
								>
									{{ _traducao('global', 'nao') }}
								</button>
							</div>
							<p class="help-block" v-show="erro.empresaEstrangeiraErro">
								{{ erro.empresaEstrangeiraErro }}
							</p>
						</div>
						<div
							v-show="
								form.empresaEstrangeira != '1' && form.empresaEstrangeira == '0'
							"
						>
							<div
								class="col-md-8 form-group"
								:class="{'has-error': erro.cnpjErro != ''}"
							>
								<span class="no-print">*</span
								><label>{{ _traducao('global', 'cnpj') }}:</label>
								<input
									type="text"
									v-mask="_vcnpj"
									v-model="form.cnpj"
									class="form-control input-sm"
								/>
								<p class="help-block" v-show="erro.cnpjErro">
									{{ erro.cnpjErro }}
								</p>
							</div>
						</div>
					</div>
					<label>{{ _traducao('global', 'contato') }}:</label><br />

					<div
						class="fornecedor_contato-card row"
						v-for="fornecedor_contato in form.fornecedor_contato.filter(
							(item) => !item.excluir
						)"
						:key="fornecedor_contato.id"
					>
						<div class="col-md-4 form-group">
							<label>{{ _traducao('global', 'nomeContato') }}:</label>
							<input
								type="text"
								v-model="fornecedor_contato.nome"
								class="form-control input-sm"
								@input="
									fornecedor_contato.nome = $event.target.value.toUpperCase()
								"
							/>
						</div>
						<div class="col-md-4 form-group">
							<label>{{ _traducao('global', 'telefone') }}:</label>
							<input
								type="text"
								v-model="fornecedor_contato.telefone"
								class="form-control input-sm"
							/>
						</div>
						<div class="col-md-4 form-group">
							<label>{{ _traducao('global', 'telefoneCelular') }}:</label>
							<input
								type="text"
								v-model="fornecedor_contato.celular"
								class="form-control input-sm"
							/>
						</div>
						<div class="col-md-6 form-group">
							<label>{{ _traducao('global', 'email') }}:</label>
							<input
								type="text"
								v-model="fornecedor_contato.email"
								class="form-control input-sm"
								@input="
									fornecedor_contato.email = $event.target.value.toLowerCase()
								"
							/>
						</div>
						<div class="col-md-6 form-group">
							<label>{{ _traducao('global', 'funcao') }}:</label>
							<input
								type="text"
								v-model="fornecedor_contato.funcao"
								class="form-control input-sm"
								@input="fornecedor_contato.funcao = $event.target.value"
							/>
						</div>
						<div class="btn-group" style="float: right; margin-right: 20px">
							<button
								class="btn btn-danger"
								style="float: right"
								@click="delete_contato(fornecedor_contato)"
							>
								<i class="fa fa-trash"></i>
							</button>
						</div>
					</div>
					<div style="margin-bottom: 30px">
						<button
							style="margin-bottom: 10px"
							class="btn btn-success"
							@click="add_contato()"
						>
							{{ _traducao('global', 'adicionarContato') }}
							<i style="margin-left: 3px" class="fa fa-plus"></i>
						</button>
					</div>

					<div class="row">
						<div class="col-md-12 form-group">
							<label
								><span class="no-print"></span
								>{{ _traducao('global', 'endereco') }}:</label
							>
							<textarea
								class="form-control input-sm"
								v-model="form.endereco"
								rows="2"
								@input="form.endereco = $event.target.value.toUpperCase()"
								style="resize: none"
							>
							</textarea>
						</div>
					</div>
					<div class="row">
						<div class="class col-md-12 form-group">
							<label
								><span class="no-print"
									>{{ _traducao('global', 'observacao') }}:</span
								></label
							>
							<textarea
								v-model="form.observacao"
								rows="10"
								class="form-control input-sm"
								@input="form.observacao = $event.target.value.toUpperCase()"
								style="resize: none"
							>
							</textarea>
						</div>
					</div>
					<div class="row">
						<div class="col-xs-12">
							<span class="label label-info pull-left no-print">
								<i class="fa fa-info-circle"></i>
								{{ _traducao('global', 'obrigatorio') }}
							</span>

							<button
								type="button"
								@click="clickSalva"
								class="btn btn-success pull-right"
							>
								<i class="fa fa-check" aria-hidden="true"></i>
								{{ _traducao('global', 'salvar').toUpperCase() }}
							</button>
						</div>
					</div>
				</div>

				<!-- info -->
				<div class="col-xs-5" v-show="!exibirForm">
					<h3 class="text-center">
						<i class="fa fa-info-circle"></i>
						{{ _traducao('menuAGnovoGrupo', 'menuAGtextoG1') }} <br /><br />
						{{ _traducao('global', 'ou') }} <br /><br />
						{{ _traducao('menuAGnovoGrupo', 'menuAGtextoG2') }}
						<i class="fa icon-editar"></i>
						{{ _traducao('menuAGnovoGrupo', 'menuAGtextoG3') }}
					</h3>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import $tabela from '../../../../mixins/tabela.js'
import flRodapeTabela from '../../../components/rodape-tabela/main.vue'

export default {
	mixins: [$tabela],

	components: {
		flRodapeTabela
	},

	props: {
		cabecalho: {
			type: Boolean,
			default: true,
			required: false
		}
	},

	data() {
		return {
			load: false,
			exibirForm: false,
			responsivity: 0,

			form: {
				id: 0,
				razao_social: '',
				id_usuario: '',
				empresaEstrangeira: '0',
				fornecedor_contato: [
					{
						nome: '',
						cnpj: '',
						telefone: '',
						celular: '',
						email: ''
					}
				],
				endereco: '',
				observacao: ''
			},

			erro: {
				razaoErro: '',
				nomeErro: '',
				telefoneErro: '',
				celularErro: '',
				emailErro: '',
				empresaEstrangeiraErro: '',
				cnpjErro: '',
				contato: ''
			},

			tabela: {
				lista: [],
				listaChunk: [],

				columns: ['id', 'razao_social', 'cnpj', 'nome'],
				inverse: 'asc',
				busca: '',
				bouse: false,

				pagination: {
					currentPage: 1,
					totalPages: 0,
					totalItens: 0,
					pageNumbers: [],
					perPage: 10
				}
			}
		}
	},
	mounted() {
		this.form.id_usuario = Number($sessao.getId())
		this.getLista()
	},
	methods: {
		atualizaLista(item) {
			var index = _.findIndex(this.tabela.lista, (o) => {
				return o.id == item.id
			})
			if (index < 0) {
				this.tabela.lista.push(item)
				bus.$emit('exibir-notificacao', {
					type: 'success',
					text: 'Fornecedor Salvo'
				})
			} else {
				this.tabela.lista[index] = item
				bus.$emit('exibir-notificacao', {
					type: 'success',
					text: 'Fornecedor Atualizado'
				})
			}

			this.filtraCore()
		},

		excluir(item) {
			var texto =
				"<h3>Deseja excluir esse fornecedor?<br/> <span class='text-danger'> " +
				item.razao_social +
				' </span> </h3>'
			this._modalExcluir(
				(retorno) => {
					if (retorno.excluir) {
						//console.log(retorno)
						this.deleta(retorno.obj)
					}
				},
				item,
				texto,
				this._traducao('global', 'excluir').toUpperCase()
			)
		},

		deleta(item) {
			bus.$emit('load-in', {text: 'Excluindo'})

			let idUser = $sessao.getId()

			this._httpGet(
				'/Fornecedor/excluir/' + item.id + '/' + idUser,
				(retorno) => {
					bus.$emit('load-out')

					if (retorno._request) {
						if (retorno._status) {
							var index = _.findIndex(this.tabela.lista, (o) => {
								return o.id == item.id
							})
							if (index >= 0) {
								// se o id for o mesmo do form limpa o form pq ele está selecionado
								if (this.tabela.lista[index].id == this.form.id) {
									this.limpaForm()
								}

								this.tabela.lista.splice(index, 1)
								this.exibirForm = false
							}

							bus.$emit('exibir-notificacao', {
								type: 'success',
								text: 'Fornecedor Excluído'
							})
							this.$emit('atualiza-lista')
							this.filtraCore()
						} else {
							bus.$emit('exibir-notificacao', {
								type: 'danger',
								text: retorno.mensagem
							})
						}
					}
				}
			)
		},

		exibirNovo() {
			this.exibirForm = true
			this.limpaForm()
		},

		limpaForm() {
			this.form.id = 0
			this.form.razao_social = ''
			this.form.id_usuario = ''
			this.form.empresaEstrangeira = '0'
			this.form.fornecedor_contato = [
				{
					nome: '',
					funcao: '',
					telefone: '',
					celular: '',
					email: ''
				}
			]
			this.form.cnpj = ''
			this.form.endereco = ''
			this.form.observacao = ''
			this.erro.razaoErro = ''
			this.erro.cnpjErro = ''
		},

		getLista() {
			this.load = true
			this._httpGet('/Fornecedor/get', (retorno) => {
				//console.log(retorno)
				if (retorno._request && retorno._status) {
					this.tabela.lista = retorno.lista
					this.filtraCore()
					this.load = false
				}
			})
		},

		editar(item) {
			this.limpaForm()

			this.exibirForm = true
			this.form.id = item.id
			this.form.empresaEstrangeira = item.estrangeiro
			this.form.cnpj = item.cnpj
			this.form.fornecedor_contato = item.fornecedor_contato
			this.form.razao_social = item.razao_social
			this.form.endereco = item.endereco
			this.form.observacao = item.observacao
		},

		clickSalva() {
			if (this.validaForm()) {
				bus.$emit('load-in', {text: this._traducao('global', 'salvando')})

				this._httpPost('/Fornecedor/salvar', this.form, (retorno) => {
					if (retorno._request && retorno._status) {
						bus.$emit('load-out')
						this.form.id = retorno.lista.id
						this.atualizaLista(retorno.lista)
						this.$emit('atualiza-lista')
						this.limpaForm()
					}
				})
			} else {
				bus.$emit('exibir-notificacao', {
					type: 'danger',
					text: this._traducao('menuEscala', 'menuEvermelho')
				})
			}
		},

		validaForm() {
			var passou = true
			var obrigatorio = this._traducao('global', 'campoObrigatorio')

			if (this.form.razao_social == '') {
				this.erro.razaoErro = obrigatorio
				passou = false
			} else {
				this.erro.razaoErro = ''
			}

			if (
				this.form.empresaEstrangeira === '' ||
				this.form.empresaEstrangeira === null
			) {
				this.erro.empresaEstrangeiraErro = obrigatorio
				passou = false
			} else {
				if (this.form.empresaEstrangeira === '0') {
					if (this.form.cnpj === '') {
						this.erro.cnpjErro = obrigatorio
						passou = false
					} else {
						this.erro.cnpjErro = ''
					}
				}
			}

			this.responsivity++
			return passou
		},
		add_contato() {
			this.form.fornecedor_contato.push({
				nome: '',
				funcao: '',
				telefone: '',
				celular: '',
				email: ''
			})
		},
		delete_contato(item) {
			item.excluir = true
			this.responsivity++
		}
	}
}
</script>
<style scoped>
.fornecedor_contato-card {
	border: 1px solid rgb(33, 150, 243);
	border-radius: 5px;
	margin: 4px;
	padding: 10px;
	margin-bottom: 15px;
}
.invisible {
	color: transparent;
}
</style>